import { Box, Button, FormControl, FormControlLabel, IconButton, InputLabel, MenuItem, Paper, Popover, Select, SelectChangeEvent, Switch, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { t } from 'i18next'
import DeleteIcon from '@mui/icons-material/Delete'
import { HsPopoverActions, HsPopoverBody, HsPopoverHeader } from './HistoryOptionsDialog'
import { NewsOptions } from '../atoms/news'
import { useIsAdmin } from '../atoms'
import { NotaOpOptions } from '../atoms/notaOperativa'

type NewsOptionsDialogPropsType = {
    open: boolean,
    anchorEl: HTMLElement,
    options: NewsOptions | NotaOpOptions,
    labelView: string,
    labelDelete: string,
    onAnnulla?: () => void,
    onSave?: (options: NewsOptions | NotaOpOptions) => void,
    onDelete?: () => void,
}

export const NewsOptionsDialog: React.FC<NewsOptionsDialogPropsType> = ({ open, anchorEl, options, onAnnulla, onSave, onDelete, labelView, labelDelete }) => {
    const [localOptions, setLocalOptions] = useState(options)
    const handleAnnulla = () => onAnnulla && onAnnulla()
    const handleClose = () => onAnnulla && onAnnulla()
    const handleSave = () => onSave && onSave(localOptions)
    const isAdmin = useIsAdmin()
    const handleDelete = () => {
        onDelete && onDelete()
        onAnnulla && onAnnulla()
    }
    const handleViewAllChanged = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
        setLocalOptions(current => ({ ...current, viewAll: checked }))
    }
    const handleChangeLimit = (ev: SelectChangeEvent<string>) => {
        setLocalOptions(current => ({ ...current, limit: Number.parseInt(ev.target.value) }))
    }
    useEffect(() => {
        // console.log(`setLocalOptions: ${JSON.stringify(options)}`)
        setLocalOptions(options)
    }, [options, open])
    return (
        <>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Paper elevation={2} sx={{ minHeight: 100, minWidth: 100, p: 0.5, backgroundColor: '#f8f8f8' }}>
                    <Box sx={{ backgroundColor: '#f8f8f8', minHeight: 100, minWidth: 100, display: 'flex', flexDirection: 'column' }}>
                        <HsPopoverHeader title={t('Opzioni News')} />
                        <HsPopoverBody>
                            {isAdmin &&
                                < Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
                                    <Typography variant='body1'>{labelDelete}</Typography>
                                    <IconButton size='small' color='primary' onClick={handleDelete}><DeleteIcon /></IconButton>
                                </Box>
                            }
                            <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                                <FormControlLabel control={<Switch checked={localOptions.viewAll} onChange={handleViewAllChanged} />} label={labelView} />
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                                <FormControl variant='standard' sx={{ flexGrow: 1 }}>
                                    <InputLabel id='numero-righe-storia-label'>Numero righe</InputLabel>
                                    <Select labelId='numero-righe-storia-label'
                                        label='Numero righe'
                                        size='small'
                                        sx={{ minWidth: 100 }}
                                        value={`${localOptions.limit}`}
                                        onChange={handleChangeLimit}>
                                        <MenuItem value={10}>10 righe</MenuItem>
                                        <MenuItem value={20}>20 righe</MenuItem>
                                        <MenuItem value={30}>30 righe</MenuItem>
                                    </Select>
                                </FormControl>
                            </Box>
                        </HsPopoverBody>
                        <HsPopoverActions>
                            <Button size='small' onClick={handleAnnulla}>ANNULLA</Button>
                            <Button size='small' onClick={handleSave}>SALVA</Button>
                        </HsPopoverActions>
                    </Box>
                </Paper>
            </Popover >
        </>
    )
}
